import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import { useMobile } from "../../../components/Layout/UseResponsive";
import { useAuth } from "../../../context/AuthContext";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceListDTO } from "../../../models/Assistance/AssistanceListDTO";
import { GetAssistanceDTO } from "../../../models/Assistance/GetAssistanceDTO";
import { Parameter } from "../../../models/Parameter";
import { BigButton } from "../../../pages/workshop/BigButton";
import { AssistanceService } from "../../../services/AssistanceService";
import { SelectItemsProps } from "../../SearchSelectComponent";
import SelectComponent from "../../SelectComponent";

export default function AssistanceWorkshopListA() {
    //Pagina
    const navigate = useNavigate();
    const intl = useIntl();
    const isMobile = useMobile(606);
    const { technicianCode } = useAuth();
    const [isLoadingResults, setIsLoadingResults] = useState<boolean>(false);
    const assistanceService = new AssistanceService();
    //Resultados
    const [assistancesData, setAssistancesData] = useState<AssistanceListDTO[]>([]);
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState<number>();
    const pageSize = 6;
    const [showAll, setShowAll] = useState<boolean>(false);

    const [technicianCodeFilter, setTechnicianCodeFilter] = useState<string>(Utilities.LoadParameterFromURLQuery("technician", "string", ""));
    const [techninians, setTechnicians] = useState<SelectItemsProps[]>([]);

    // módulos ativos
    const { availableModules, canTechnicianSeeAllAssistances } = useAvailableModulesContext();

    const fetchData = async (page: number) => {
        setIsLoadingResults(true);
        var searchUrl: string = Utilities.CreateSearchURL([`page=${page}`]);

        navigate(`/workshop/assistances${searchUrl}`, { replace: true });

        var response = await assistanceService.GetAll(mountSearchParameters(), Utilities.MountSortParameters([]), page, pageSize);

        if (response.success !== true) {
            setAssistancesData([]);
            setPageCount(0);
            setIsLoadingResults(false);
            Toast.Show("error", response.message);
            return;
        }

        if (response.items.length === 0) {
            setCurrentPage(1);
            setPageCount(0);
            Toast.Show("info", "Não existe nenhuma assistência com esses dados");
        }

        setAssistancesData(response.items);
        setPageCount(response.totalPages);
        setIsLoadingResults(false);
        setCurrentPage(page);
    };

    const mountSearchParameters = (): Parameter[] => {
        var parameters: Parameter[] = [];
        parameters.push(new Parameter("status", "ABERTURA,EM_CURSO"));
        if (showAll === false) {
            parameters.push(new Parameter("technician", technicianCode === null ? "vazio" : technicianCode));
        }
        else {
            parameters.push(new Parameter("technician", technicianCodeFilter));
        }
        return parameters;
    };

    const getAssistance = async (docType: string, serie: string, number: number, supportNumber?: string | null) => {
        setIsLoadingResults(true);
        var assistance: GetAssistanceDTO = {
            docType: docType,
            serie: serie,
            number: number,
            supportNumber: supportNumber,
        };
        var response = await assistanceService.GetAssistance(assistance);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoadingResults(false);
            return;
        }

        navigate(`/Workshop/Assistance/${response.obj?.id}`);
        setIsLoadingResults(false);
    };

    const getTechnicians = async () => {
        const list: SelectItemsProps[] = [];
        var response = await assistanceService.GetWorkshopTechniciansWithCode();

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: element.name,
            };
            list.push(item);
        });

        setTechnicians(list);
    };

    const handleNavigation = async (assistanceCardPosition: number) => {
        if (assistanceCardPosition < 0) {
            assistanceCardPosition = 0;
        }
        if (assistanceCardPosition >= 0 && assistanceCardPosition < assistancesData.length) {
            navigate(`/Workshop/Assistance/${assistancesData[assistanceCardPosition].assistanceId}`);
        } else {
            console.error("Index (negativo):", assistanceCardPosition);
        }
    };

    useEffect(() => {
        fetchData(page ?? 1);
    }, [showAll]);

    useEffect(() => {
        getTechnicians();
    }, []);

    return (
        <>
            <Row style={{ justifyContent: "center", alignItems: "center", marginTop: "10px", }}>
                {(canTechnicianSeeAllAssistances && isLoadingResults === false) ? (
                    <ButtonComponent
                        onClick={() => {
                            setShowAll(!showAll);
                            setTechnicianCodeFilter("");
                        }}
                        text={intl.formatMessage({ id: showAll ? "AssistanceWorkshopListA.ShowMine" : "AssistanceWorkshopListA.ShowAll" })}
                        style={{ width: isMobile ? "90%" : "30%" }}
                    />
                ) : (
                    ""
                )}
            </Row>

            {showAll && (
                <Row style={{ justifyContent: "center", marginTop: "20px", alignItems: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", flexDirection: isMobile ? "column" : "row", alignItems: "center" }}>
                        <SelectComponent
                            xl={2}
                            lg={3}
                            md={5}
                            sm={12}
                            xs={12}
                            style={{ width: isMobile ? "90%" : "100%", height: "43px" }}
                            label={"Técnico"}
                            selectedItemValue={technicianCodeFilter}
                            items={techninians}
                            onChange={(t: string) => {
                                setTechnicianCodeFilter(t);
                            }}
                        />
                        <ButtonComponent
                            onClick={() => fetchData(currentPage ?? 1)}
                            text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                            style={{ width: isMobile ? "90%" : "5%", height: "43px", marginTop: isMobile ? "10px" : "22px", marginLeft: isMobile ? "0px" : "10px" }}
                        />
                    </div>
                </Row>
            )}

            {isLoadingResults ? (
                <Row style={{ justifyContent: "center", alignItems: "center" }}>
                    <div
                        className="loading"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <span>
                            {" "}
                            <FormattedMessage id="Common.Loading.DataLoading" />
                            ...{" "}
                        </span>
                        <CircularProgress style={{ marginLeft: "10px" }} size={"25px"} />
                    </div>
                </Row>
            ) : (
                assistancesData.length > 0 && (
                    <Row style={{ justifyContent: "center", alignItems: "center" }}>
                        {assistancesData.map((element, index) => {
                            const i = index + 1;

                            if (index % 2 !== 0) {

                                return (
                                    <Row key={index - 2} style={{ justifyContent: "center", alignItems: "center", marginTop: "11px" }}>
                                        <Col
                                            xl={2}
                                            lg={2}
                                            md={6}
                                            sm={6}
                                            xs={10}
                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                        >
                                            {assistancesData[i - 2] && (
                                                <BigButton
                                                    path={""}
                                                    onClickFunction={() =>
                                                        assistancesData[index].assistanceId ?
                                                            handleNavigation(i - 2) :
                                                            getAssistance(
                                                                assistancesData[i - 2].docType,
                                                                assistancesData[i - 2].serie,
                                                                assistancesData[i - 2].number,
                                                                assistancesData[i - 2].supportNumber
                                                            )
                                                    }
                                                    label={
                                                        availableModules.includes("ShowClientNameForAssistanceCardsWorkshopView")
                                                            ? `${(assistancesData[i - 2].docType + assistancesData[i - 2].serie + assistancesData[i - 2].number) === "0"
                                                                ? `${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 2]?.supportNumber ? `${assistancesData[i - 2].supportNumber}` : ""}`
                                                                : `${assistancesData[i - 2].docType} ${assistancesData[i - 2].serie} ${assistancesData[i - 2].number}${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 2]?.supportNumber ? ` | ${assistancesData[i - 2].supportNumber}` : ""}`}\n${assistancesData[i - 2].client?.erpId} - ${assistancesData[i - 2].client?.name}\n${assistancesData[i - 2].equipment ? `${assistancesData[i - 2].equipment.brand || ''} - ${assistancesData[i - 2].equipment.model || ''} - ${assistancesData[i - 2].equipment.serialNumber || ''}` : ''}\n${(assistancesData[i - 2]?.technician && assistancesData[i - 2]?.technician !== '') ? assistancesData[i - 2].technician : 'Não atribuído'}\n${assistancesData[i - 2].status}`
                                                            : `${(assistancesData[i - 2].docType + assistancesData[i - 2].serie + assistancesData[i - 2].number) === "0"
                                                                ? `${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 2]?.supportNumber ? `${assistancesData[i - 2].supportNumber}` : ""}`
                                                                : `${assistancesData[i - 2].docType} ${assistancesData[i - 2].serie} ${assistancesData[i - 2].number}${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 2]?.supportNumber ? ` | ${assistancesData[i - 2].supportNumber}` : ""}`}\n${assistancesData[i - 2].client?.erpId}\n${assistancesData[i - 2].equipment ? `${assistancesData[i - 2].equipment.brand || ''} - ${assistancesData[i - 2].equipment.model || ''} - ${assistancesData[i - 2].equipment.serialNumber || ''}` : ''}\n${(assistancesData[i - 2]?.technician && assistancesData[i - 2]?.technician !== '') ? assistancesData[i - 2].technician : 'Não atribuído'}\n${assistancesData[i - 2].status}`}
                                                    alignItems={"center"}
                                                    height={"100%"}
                                                    fontSize={"15px"}
                                                />
                                            )}
                                        </Col>
                                        <Col
                                            xl={2}
                                            lg={2}
                                            md={6}
                                            sm={6}
                                            xs={10}
                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                        >
                                            {assistancesData[i - 1] && (
                                                <BigButton
                                                    path={""}
                                                    onClickFunction={() =>
                                                        assistancesData[index].assistanceId ?
                                                            handleNavigation(i - 1) :
                                                            getAssistance(
                                                                assistancesData[i - 1].docType,
                                                                assistancesData[i - 1].serie,
                                                                assistancesData[i - 1].number,
                                                                assistancesData[i - 1].supportNumber
                                                            )
                                                    }
                                                    label={
                                                        availableModules.includes("ShowClientNameForAssistanceCardsWorkshopView")
                                                            ? `${(assistancesData[i - 1].docType + assistancesData[i - 1].serie + assistancesData[i - 1].number) === "0"
                                                                ? `${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 1]?.supportNumber ? `${assistancesData[i - 1].supportNumber}` : ""}`
                                                                : `${assistancesData[i - 1].docType} ${assistancesData[i - 1].serie} ${assistancesData[i - 1].number}${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 1]?.supportNumber ? ` | ${assistancesData[i - 1].supportNumber}` : ""}`}\n${assistancesData[i - 1].client?.erpId} - ${assistancesData[i - 1].client?.name}\n${assistancesData[i - 1].equipment ? `${assistancesData[i - 1].equipment.brand || ''} - ${assistancesData[i - 1].equipment.model || ''} - ${assistancesData[i - 1].equipment.serialNumber || ''}` : ''}\n${(assistancesData[i - 1]?.technician && assistancesData[i - 1]?.technician !== '') ? assistancesData[i - 1].technician : 'Não atribuído'}\n${assistancesData[i - 1].status}`
                                                            : `${(assistancesData[i - 1].docType + assistancesData[i - 1].serie + assistancesData[i - 1].number) === "0"
                                                                ? `${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 1]?.supportNumber ? `${assistancesData[i - 1].supportNumber}` : ""}`
                                                                : `${assistancesData[i - 1].docType} ${assistancesData[i - 1].serie} ${assistancesData[i - 1].number}${availableModules.includes("IsActiveErpSupportModule") && assistancesData[i - 1]?.supportNumber ? ` | ${assistancesData[i - 1].supportNumber}` : ""}`}\n${assistancesData[i - 1].client?.erpId}\n${assistancesData[i - 1].equipment ? `${assistancesData[i - 1].equipment.brand || ''} - ${assistancesData[i - 1].equipment.model || ''} - ${assistancesData[i - 1].equipment.serialNumber || ''}` : ''}\n${(assistancesData[i - 1]?.technician && assistancesData[i - 1]?.technician !== '') ? assistancesData[i - 1].technician : 'Não atribuído'}\n${assistancesData[i - 1].status}`}
                                                    alignItems={"center"}
                                                    height={"100%"}
                                                    fontSize={"15px"}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                );
                            } else if (i === assistancesData.length) {
                                // Se for o último elemento ímpar, exibe-o sozinho
                                return (
                                    <Row key={index} style={{ justifyContent: "center", alignItems: "center", marginTop: "11px" }}>
                                        <Col
                                            xl={2}
                                            lg={2}
                                            md={6}
                                            sm={6}
                                            xs={10}
                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                        >
                                            <BigButton
                                                path={""}
                                                onClickFunction={() =>
                                                    assistancesData[index].assistanceId ?
                                                        handleNavigation(index) :
                                                        getAssistance(
                                                            assistancesData[index].docType,
                                                            assistancesData[index].serie,
                                                            assistancesData[index].number,
                                                            assistancesData[index].supportNumber,
                                                        )
                                                }
                                                label={
                                                    availableModules.includes("ShowClientNameForAssistanceCardsWorkshopView")
                                                        ? `${(assistancesData[index].docType + assistancesData[index].serie + assistancesData[index].number) === "0"
                                                            ? `${availableModules.includes("IsActiveErpSupportModule") && assistancesData[index]?.supportNumber ? `${assistancesData[index].supportNumber}` : ""}`
                                                            : `${assistancesData[index].docType} ${assistancesData[index].serie} ${assistancesData[index].number}${availableModules.includes("IsActiveErpSupportModule") && assistancesData[index]?.supportNumber ? ` | ${assistancesData[index].supportNumber}` : ""}`}\n${assistancesData[index].client?.erpId} - ${assistancesData[index].client?.name}\n${assistancesData[index].equipment ? `${assistancesData[index].equipment.brand || ''} - ${assistancesData[index].equipment.model || ''} - ${assistancesData[index].equipment.serialNumber || ''}` : ''}\n${assistancesData[index]?.technician ?? 'Não atribuído'}\n${assistancesData[index].status}`
                                                        : `${(assistancesData[index].docType + assistancesData[index].serie + assistancesData[index].number) === "0"
                                                            ? `${availableModules.includes("IsActiveErpSupportModule") && assistancesData[index]?.supportNumber ? `${assistancesData[index].supportNumber}` : ""}`
                                                            : `${assistancesData[index].docType} ${assistancesData[index].serie} ${assistancesData[index].number}${availableModules.includes("IsActiveErpSupportModule") && assistancesData[index]?.supportNumber ? ` | ${assistancesData[index].supportNumber}` : ""}`}\n${assistancesData[index].client?.erpId}\n${assistancesData[index].equipment ? `${assistancesData[index].equipment.brand || ''} - ${assistancesData[index].equipment.model || ''} - ${assistancesData[index].equipment.serialNumber || ''}` : ''}\n${assistancesData[index]?.technician ?? 'Não atribuído'}\n${assistancesData[index].status}`}
                                                alignItems={"center"}
                                                height={"100%"}
                                                fontSize={"15px"}
                                            />
                                        </Col>
                                    </Row>
                                );
                            }
                        })}
                    </Row>
                )
            )}


            <Row style={{ justifyContent: "center", alignItems: "center", margin: "20px 0px" }}>
                <Col xl={1} lg={2} md={3} sm={3} xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "AssistanceWorkshopListA.Previous" })}
                        onClick={() => fetchData(currentPage ? currentPage - 1 : 1)}
                        disabled={isLoadingResults || (currentPage && currentPage <= 1) ? true : false}
                    />
                </Col>
                <Col xl={2} lg={2} md={3} sm={3} xs={4} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <span className="paginationNumberIndicator">
                        <FormattedMessage id="Common.Labels.Page" /> <strong>{currentPage}</strong>{" "}
                        <FormattedMessage id="Common.Labels.Of" /> <strong>{pageCount}</strong>
                    </span>
                </Col>
                <Col xl={1} lg={2} md={3} sm={3} xs={4} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "AssistanceWorkshopListA.Next" })}
                        onClick={() => fetchData(currentPage ? currentPage + 1 : pageCount)}
                        disabled={isLoadingResults || (currentPage && currentPage >= pageCount) ? true : false}
                    />
                </Col>
            </Row>
        </>
    );
}
